import React, { Suspense, useState } from "react";
import { Redirect, Switch } from "react-router-dom";
import { LayoutSplashScreen, ContentRoute } from "../_metronic/layout";
import { BuilderPage } from "./pages/BuilderPage";
import Profile from "./pages/Profile";
import Support from "./pages/Support";
import Clients from "./pages/CatalogClients/Clients";
import Category from "./pages/CatalogCategories/Category";
import Metrics from "./pages/CatalogMetrics/Metrics";
import Locations from "./pages/CatalogLocations/Locations";
import Employees from "./pages/CatalogEmployees/Employees"
import Verify from './pages/UserVerify'
import Users from "./pages/CatalogUsers/Users"
import InternalUsers from "./pages/CatalogInternalUsers/Users"
import NewCampaign from "./pages/Campaign/Campaign"
import Campaign from "./pages/Campaign/CampaignTable"
import CampaignPreview from "./pages/Campaign/CampaingPreview"
import Groups from "./pages/CatalogGroups/Groups"
import Regions from "./pages/CatalogRegions/Regions"
import Admins from "./pages/CatalogAdmins/Admins"
import Products from "./pages/CatalogProducts/Products"
import Tasks from "./pages/CatalogTasks/Tasks"
import ResetPassword from "./pages/ResetPassword"
import Payments from "./pages/CatalogPayments/Payments"
import { DashboardPage } from "./pages/DashboardPage";
import CustomerDetails from "./pages/CatalogClients/ClientDetails"
import ProductDetails from "./pages/CatalogProducts/ProductDetails"
import NewCompetionProduct  from "./pages/CatalogProducts/Components/Page/NewCompetionProduct";



export default function BasePage() {

    return (
        <Suspense fallback={<LayoutSplashScreen />}>

            <Switch>
                {
                    <Redirect exact from="/" to="/dashboard" />
                }
                <ContentRoute path="/dashboard" component={DashboardPage}  />
                <ContentRoute path="/builder" component={BuilderPage}  />
                <ContentRoute path="/user/profile" component={Profile}  />
                <ContentRoute path="/support" component={Support}  />
                <ContentRoute exact path="/Customers" component={Clients}  />
                <ContentRoute exact path="/Customers/:uid" component={CustomerDetails}  />

                <ContentRoute path="/employees" component={Employees}  />
                <ContentRoute exact path="/products" component={Products}  />
                <ContentRoute exact path="/products/:uid" component={ProductDetails} />
                <ContentRoute exact path="/products/:uid/competition/new" component={NewCompetionProduct} />

                <ContentRoute path="/admins" component={Admins}  />

                <ContentRoute path="/regions" component={Regions}  />
                <ContentRoute path="/categories" component={Category}  />
                <ContentRoute path="/payments" component={Payments}  />
                <ContentRoute path="/metrics" component={Metrics}  />
                <ContentRoute path="/pos" component={Locations}  />
                <ContentRoute path="/app-users" component={Users}  />
                <ContentRoute path="/internal-users" component={InternalUsers}  />
                <ContentRoute path="/tasks" component={Tasks}  />
                <ContentRoute path="/profiles" component={Groups}  />

                <ContentRoute path="/user/reset-password" component={ResetPassword}  />
                <ContentRoute path="/user/verify" component={Verify}  />

                <ContentRoute exact path="/campaign/new" component={NewCampaign}  />
                <ContentRoute exact path="/campaign/preview/:uid" component={CampaignPreview}  />
                <ContentRoute exact path="/campaign/edit/:uid" component={NewCampaign}  />
                <ContentRoute exact path="/campaign" component={Campaign}  />


                <Redirect to="error/404" />
            </Switch>
        </Suspense>
    );
}